import script from "./PopBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./PopBtn.vue?vue&type=script&lang=ts&setup=true"

import "./PopBtn.vue?vue&type=style&index=0&id=3f35bb82&scoped=true&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f35bb82"]])

export default __exports__